import { Component, OnInit } from '@angular/core';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';

@Component({
  selector: 'app-rejected-withdrawals',
  templateUrl: './rejected-withdrawals.component.html',
  styleUrls: ['./rejected-withdrawals.component.scss'],
})
export class RejectedWithdrawalsComponent implements OnInit {
  public error = null;
  public rejectedWithdrawals: any[] = [];
  public emailMeDisabled: boolean = false;

  constructor(
    private withdrawalService: WithdrawalService) {}

    ngOnInit(){
      this.onGetRejectedWithdrawals();
    }

    onGetRejectedWithdrawals() {
      this.rejectedWithdrawals = [];
      this.withdrawalService.callGetRejectedTransactions().subscribe(
        (response: any) => {
          if (response && !!response.result) {
            const tempTransactions: any = response.payload.rejected_transactions;
            for (const index in tempTransactions) {
              this.rejectedWithdrawals.push(tempTransactions[index]);
            }
          }
        },
        (error) => {
          this.error = error;
        }
      );
    }

    onEmailMeClicked() {
      this.emailMeDisabled = true;
    }
}
